import { render } from "./Holi.vue?vue&type=template&id=ccf8c9d8"
import script from "./Holi.vue?vue&type=script&lang=js"
export * from "./Holi.vue?vue&type=script&lang=js"
script.render = render

export default script